import { createContext, FC, useContext } from 'react';

import oneObject from '#/bootstrap/oneObject';

import { GlobalContextInterface } from './GlobalState';

export const defaultGlobalContext: GlobalContextInterface = {
  boot: {
    isBooted: false,
    isActive: false,
    isDictionaryReady: false,
    isPluginManagerReady: false,
  },
  theme: oneObject.config.theme,
};

export const GlobalContext = createContext(defaultGlobalContext);

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalContextProvider: FC<{ config: GlobalContextInterface }> = ({
  children,
  config,
}) => (
  <GlobalContext.Provider value={config}>{children}</GlobalContext.Provider>
);
